import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Acesso} from "src/app/core/acesso";
import {CarregarPerfil} from "src/app/core/carregar-perfil";
import {ToastService} from "src/app/services/toast/toast.service";
import {Rim} from "../../../core/rim";
import {RimService} from "../../../services/rim/rim.service";
import {DataUtilService} from "../../../services/commons/data-util.service";
import {LoadingPopupService} from "../../../services/loadingPopup/loading-popup.service";
import {FileUtils} from "../../../utils/file-utils";
import {CapituloRim} from "../../../core/capitulo-rim";
import {switchMap} from "rxjs/operators";
import {forkJoin, Observable, of} from "rxjs";
import {ArquivoConteudoRimService} from "../../../services/arquivo-conteudo-rim/arquivo-conteudo-rim.service";
import {ArquivoMetadados} from "../../../core/arquivo-metadado";
import {ConteudoRim} from "../../../core/conteudo-rim";
import {BotoesRelatorioRimComponent} from "../botao-relatorio/botao-relatorio.component";
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {ConsultaBanco} from "../../../core/consulta-banco";
import {ConsultaBancoService} from "../../../services/consulta-banco/consulta-banco.service";
import {ConteudoTabelaRimComponent} from "./conteudo-tabela-rim/conteudo-tabela-rim.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {ConfirmDialogComponent} from "../../common/confirm-dialog/confirm-dialog.component";

@Component({
    selector: "cadastrar-rim",
    templateUrl: "./cadastrar-rim.component.html",
    styleUrls: ["./cadastrar-rim.component.css"],
})
export class CadastrarRimComponent implements OnInit {
    rim: Rim = new Rim();

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    mostrarBotaoCadastrar = true;
    mostrarBotaoAtualizar = true;

    isAtualizar: boolean = false;

    idsConteudoAnexado = [];

    consultasBanco: ConsultaBanco[];

    constructor(private rimService: RimService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private toastService: ToastService,
                private dataUtilService: DataUtilService,
                private loadingPopupService: LoadingPopupService,
                private fileUtils: FileUtils,
                private arquivoConteudoRimService: ArquivoConteudoRimService,
                private botoesRelatorio: MatBottomSheet,
                private consultaBancoService: ConsultaBancoService,
                private dialog: MatDialog) {
    }

    ngOnInit() {
        this.carregarPerfil.carregar(
            this.activatedRoute.snapshot.data.perfilAcesso,
            this.perfilAcesso
        );

        if (!this.perfilAcesso.insere) {
            this.mostrarBotaoCadastrar = false;
        }

        if (!this.perfilAcesso.altera) {
            this.mostrarBotaoAtualizar = false;
        }

        const id = this.activatedRoute.snapshot.queryParams.id || null;
        if (id) {

            this.consultaBancoService.getByIdRim(id).subscribe((consultas: ConsultaBanco[]) => {
                this.consultasBanco = consultas;

                this.rimService.getById(id).subscribe((rim: Rim) => {
                    this.carregarRim(rim);

                    const duplicar = this.activatedRoute.snapshot.queryParams.duplicar || null;
                    if (duplicar) {
                        this.isAtualizar = false;
                        this.rim.id = null;
                        this.rim.finalizado = false;
                        this.rim.modeloPadrao = false;
                        this.rim.capitulos.forEach(capitulo => {
                            capitulo.id = null;
                            this.processarConteudo(capitulo.conteudos);
                        });
                    }
                });
            });
        }
    }

    private processarConteudo(conteudos: ConteudoRim[]) {
        conteudos.forEach(conteudo => {
            if (conteudo.cabecalhosTabela)
                conteudo.cabecalhosTabela.forEach(cabecalho => cabecalho.id = null);
            if (conteudo.colunas)
                conteudo.colunas.forEach(coluna => coluna.id = null);
            if (conteudo.metadados)
                this.duplicarConteudoAnexo(conteudo);
            if (conteudo.subConteudos)
                this.processarConteudo(conteudo.subConteudos);

            conteudo.id = null;
        });
    }

    private duplicarConteudoAnexo(conteudo: ConteudoRim) {
        conteudo.metadados.id = null;
        this.arquivoConteudoRimService.get(conteudo.id).subscribe(
            (res) => {
                const blob = new Blob([res], {type: conteudo.metadados.dsTipoArquivo});
                const file = new File([blob], conteudo.metadados.nmArquivo, {type: conteudo.metadados.dsTipoArquivo});
                conteudo.anexo = file;
                conteudo.isAnexoAlterado = true;
            },
            (err) => this.toastService.showAlerta("Erro ao baixar arquivo!")
        );
    }

    private carregarRim(rim: Rim) {
        rim.dataInicio = this.dataUtilService.getDataTruncata(rim.dataInicio);
        rim.dataFim = this.dataUtilService.getDataTruncata(rim.dataFim)
        this.rim = rim;
        this.isAtualizar = true;
    }

    mostrarBotaoLimpar() {
        if (this.isAtualizar) return false;
        if (!this.mostrarBotaoAtualizar) return false;
        if (!this.mostrarBotaoCadastrar) return false;

        return true;
    }

    private processCapitulos(rim: Rim, rimUpdated: Rim): Observable<any> {
        this.idsConteudoAnexado = [];
        const anexosObservables = [];

        rim.capitulos?.forEach(capitulo => {
            capitulo.conteudos?.forEach(conteudo => {
                this.processarConteudoAnexo(conteudo, null, rimUpdated, capitulo, anexosObservables);
                if (conteudo.subConteudos)
                    conteudo.subConteudos.forEach(subConteudo => {
                        this.processarConteudoAnexo(conteudo, subConteudo, rimUpdated, capitulo, anexosObservables);
                    })
            });
        });
        this.carregarRim(rimUpdated);
        return anexosObservables.length > 0 ? forkJoin(anexosObservables) : of([]);
    }

    private processarConteudoAnexo(conteudo: ConteudoRim, subConteudo: ConteudoRim, rimUpdated: Rim, capitulo: CapituloRim, anexosObservables: Observable<any>[]) {
        const isMatchingCapitulo = (capA : CapituloRim, capB: CapituloRim) => (
            capA.id === capB.id ||
            (capA.posicao === capB.posicao &&
                capA.novaPagina === capB.novaPagina &&
                capA.descricao === capB.descricao)
        );

        const isMatchingConteudo = (contA: ConteudoRim, contB: ConteudoRim) => (
            contA.id === contB.id ||
            (contA.posicao === contB.posicao &&
                contA.descricao === contB.descricao &&
                contA.alinhamento === contB.alinhamento &&
                contA.descricaoBold === contB.descricaoBold &&
                contA.descricaoItalic === contB.descricaoItalic &&
                contA.valorBold === contB.valorBold &&
                contA.valorItalic === contB.valorItalic &&
                contA.novaPagina === contB.novaPagina &&
                contA.tipoConteudoRim.id === contB.tipoConteudoRim.id));

        if ((conteudo.anexo && conteudo.isAnexoAlterado && !subConteudo) ||
            (subConteudo && subConteudo.anexo && subConteudo.isAnexoAlterado)) {
            const capituloIndex = rimUpdated.capitulos.findIndex(c => isMatchingCapitulo(c, capitulo));

            if (capituloIndex !== -1) {
                const conteudoIndex = rimUpdated.capitulos[capituloIndex].conteudos.findIndex(c =>
                    !this.idsConteudoAnexado.includes(c.id) && isMatchingConteudo(c, conteudo));

                let conteudoIdTarget: number;
                let arquivoAnexo: File;
                if (!subConteudo) {
                    var conteudoAlteracao = rimUpdated.capitulos[capituloIndex].conteudos[conteudoIndex];
                    conteudoIdTarget = conteudoAlteracao.id;
                    arquivoAnexo = conteudo.anexo;

                    if (!conteudoAlteracao.metadados)
                        conteudoAlteracao.metadados = new ArquivoMetadados();

                    conteudoAlteracao.anexo = arquivoAnexo;
                    conteudoAlteracao.metadados.nmArquivo = arquivoAnexo.name;
                    conteudoAlteracao.metadados.dsTipoArquivo = arquivoAnexo.type;
                } else {
                    const subConteudoIndex = rimUpdated.capitulos[capituloIndex].conteudos[conteudoIndex].subConteudos.findIndex(c =>
                        !this.idsConteudoAnexado.includes(c.id) && isMatchingConteudo(c, subConteudo));
                    var conteudoAlteracao = rimUpdated.capitulos[capituloIndex].conteudos[conteudoIndex].subConteudos[subConteudoIndex];
                    conteudoIdTarget = conteudoAlteracao.id;
                    arquivoAnexo = subConteudo.anexo;

                    if (!conteudoAlteracao.metadados)
                        conteudoAlteracao.metadados = new ArquivoMetadados();

                    conteudoAlteracao.anexo = arquivoAnexo;
                    conteudoAlteracao.metadados.nmArquivo = arquivoAnexo.name;
                    conteudoAlteracao.metadados.dsTipoArquivo = arquivoAnexo.type;
                }

                anexosObservables.push(this.arquivoConteudoRimService.gravar(arquivoAnexo, conteudoIdTarget));
                this.idsConteudoAnexado.push(conteudoIdTarget);
            }
        }
    }

    cadastrar() {
        if (!this.validarDatas()) return;

        this.rimService.cadastrar(this.rim)
            .pipe(switchMap((rimCadastrado: Rim) => this.processCapitulos(this.rim, rimCadastrado)))
            .subscribe(() => {
                this.router.navigate(["rim/cadastrar"], {
                    queryParams: {id: this.rim.id},
                });
                this.toastService.showSucesso("Cadastro realizado com sucesso")
            });
    }

    atualizar() {
        if (!this.validarDatas()) return;

        this.rimService.alterar(this.rim)
            .pipe(switchMap((rimAlterado: Rim) => this.processCapitulos(this.rim, rimAlterado)))
            .subscribe(() => this.toastService.showSucesso("Registro atualizado com sucesso"));
    }

    limpar() {
        this.rim = new Rim();
    }

    cancelar() {
        this.router.navigate(["rim"]);
    }

    camposDesabilitados() {
        if (this.rim.finalizado) return true;

        if (this.isAtualizar) {
            return !this.perfilAcesso.altera;
        }
        return !this.perfilAcesso.insere;
    }

    validarDatas(): boolean {
        const dataInicio = this.dataUtilService.getDataTruncata(
            this.rim.dataInicio
        );
        const dataFim = this.dataUtilService.getDataTruncata(
            this.rim.dataFim
        );

        if (dataFim) {
            if (dataInicio && dataInicio.getTime() > dataFim.getTime()) {
                this.toastService.showAlerta(
                    "A data de início informada não pode ser maior que a data de fim."
                );
                return false;
            }
        }
        return true;
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    onValorChangeContrato(registro: any) {
        this.rim.contrato = registro;
    }

    onValorChangeUnidade(registro: any) {
        this.rim.unidade = registro;
    }

    getRelatorio(tipo: string) {
        if (!tipo)
            return;

        this.loadingPopupService.mostrarMensagemDialog('Gerando relatório ..');

        this.rimService.showRelatorio(this.rim.id, tipo).subscribe(
            response => {
                if (tipo == 'PDF') {
                    this.fileUtils.showFilePDF(response);
                } else if (tipo == 'DOCX') {
                    this.fileUtils.downloadFile(response, 'RIM.docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
                }
            },
            responseError => {
                const dataView = new DataView(responseError.error);
                const decoder = new TextDecoder('utf8');
                const resp = JSON.parse(decoder.decode(dataView));
                this.toastService.showAlerta(resp.mensagem);

            }).add(() => {
            this.loadingPopupService.closeDialog();
        });
    }

    abrirOpcoesRelatorio() {
        const botoesRelatorioRef = this.botoesRelatorio.open(BotoesRelatorioRimComponent);
        botoesRelatorioRef.afterDismissed().subscribe((tipo) => {
            this.getRelatorio(tipo);
        });
    }

    addCapituloRim() {
        if (!this.rim.capitulos)
            this.rim.capitulos = [];

        const capitulo: CapituloRim = new CapituloRim();
        capitulo.conteudos = [];
        capitulo.posicao = Math.max(0, ...this.rim.capitulos.map(c => c.posicao)) + 1;
        this.rim.capitulos.push(capitulo);
    }

    recarregarTodasTabelas() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: "Recarregar dados de todas as Tabelas",
            textoAuxiliar: "Deseja realmente recarregar os dados de todas as tabelas do RIM?",
            textoConfirma: "Sim",
            textoCancela: "Não",
        };

        this.dialog.open(ConfirmDialogComponent, dialogConfig).afterClosed().subscribe((confirma) => {
            if (confirma) {
                this.loadingPopupService.mostrarMensagemDialog('Recarregando todas as tabelas...');

                // Procurar todos os componentes de tabela através do DOM
                const id = this.activatedRoute.snapshot.queryParams.id || null;
                if (!id) {
                    this.toastService.showAlerta("É necessário salvar o RIM antes de recarregar as tabelas");
                    this.loadingPopupService.closeDialog();
                    return;
                }

                // Coletar todos os conteúdos do tipo tabela de todos os capítulos
                const tabelas = [];
                this.rim.capitulos.forEach(capitulo => {
                    this.coletarTabelasRecursivamente(capitulo.conteudos, tabelas);
                });

                if (tabelas.length === 0) {
                    this.toastService.showAlerta("Nenhuma tabela encontrada para recarregar");
                    this.loadingPopupService.closeDialog();
                    return;
                }

                // Criar uma lista de observables para recarregar todas as tabelas
                const recarregarObservables = [];
                tabelas.forEach(conteudo => {
                    conteudo.cabecalhosTabela = [];
                });

                this.toastService.showSucesso("Todas as tabelas foram recarregadas com sucesso");
                this.loadingPopupService.closeDialog();
            }
        });
    }

    private coletarTabelasRecursivamente(conteudos: ConteudoRim[], tabelas: ConteudoRim[]) {
        if (!conteudos) return;

        conteudos.forEach(conteudo => {
            // Verificar se é um conteúdo do tipo tabela
            if (conteudo.tipoConteudoRim?.id === 5) { // Assumindo que o id 3 é para tabelas
                tabelas.push(conteudo);
            }

            // Verificar subconteúdos recursivamente
            if (conteudo.subConteudos) {
                this.coletarTabelasRecursivamente(conteudo.subConteudos, tabelas);
            }
        });
    }

}
